import type { ClientToolGroup } from '@cc/schema';

/**
 * E57 · ONE NAME PER TOOL — the app's own names everywhere in the portal (founder Q-pia-6 A; Q-e57g1-3 A keeps the clinical
 * names for the two plain client-facing phrases: Check-ins, Functional analysis). Each tool's label is the APP'S i18n key
 * (the Toolkit's `learn.tools.*`, the hub tabs' own keys), so the portal and the phone can never name a tool two ways and
 * the Russian is the app's Russian.
 */
export const TOOL_LABEL_KEYS: Readonly<Record<string, string>> = {
  homework: 'homework.hub.tab',
  worksheets: 'worksheets.hub.tab',
  assessments: 'learn.tools.Tests',
  checkins: 'checkIn.hub.tab',
  diarycard: 'diaryCard.hub.tab',
  'sleep-diary': 'sleep.hub.tab',
  health: 'health.hub.tab',
  conceptualizations: 'pages.conceptualization.conceptualizations',
  'vicious-cycles': 'learn.tools.ViciousCycles',
  'functional-analysis': 'fa.hub.title',
  modes: 'modes.hub.title',
  'thought-tests': 'learn.tools.ThoughtsTesting',
  'abc-models': 'learn.tools.AbcModels',
  'downward-arrows': 'learn.tools.DownwardArrows',
  'worry-trees': 'learn.tools.WorryTrees',
  'coping-cards': 'learn.tools.CopingCards',
  'behavioral-activation': 'learn.tools.ActivateHome',
  'behavior-experiments': 'learn.tools.BehaviorExperiments',
  exposures: 'learn.tools.Exposures',
  values: 'learn.tools.ValuesProfile',
  meditations: 'learn.tools.Meditations',
  motivation: 'mi.hub.title',
  safetyplan: 'safetyPlan.hub.tab',
  sessions: 'clientPage.group.sessions',
};

export const GROUP_LABEL_KEYS: Readonly<Record<ClientToolGroup, string>> = {
  plan: 'clientPage.group.plan',
  track: 'clientPage.group.track',
  formulation: 'clientPage.group.formulation',
  skills: 'clientPage.group.skills',
  safety: 'clientPage.group.safety',
};

export const toolLabel = (t: (key: string, opts?: Record<string, unknown>) => string, tool: string): string =>
  t(TOOL_LABEL_KEYS[tool] ?? tool);
